module.exports = {
	"24088": {
		"url": "http://douglassandzook.com",
		"data": {
			"copyright": {
				"text": "Forest Lawn Memorial-Park Association"
			},
			"disclaimer": "We respect your privacy and will not sell your personal information. Your information will be used to periodically communicate with you about our offerings and events. Please check our <a href='https://douglassandzook.com/privacy/'><u>Douglass & Zook Privacy Policy and Terms of Use</u></a> by clicking here, or visit <a href='https://douglassandzook.com/privacy/'><u>www.douglassandzook.com/privacy</u></a>.",
			"locations": {
				"corporate": "DOUGLASS & ZOOK FUNERAL AND CREMATION SERVICES · 600 E. FOOTHILL BOULEVARD, MONROVIA, CA 91016 · FD 221"
			},
			"menu": [
				{
					"name": "Privacy Policy",
					"url": "http://www.douglassandzook.com/privacy-policy/",
					"target": "_blank"
				},
				{
					"name": "Terms and Conditions",
					"url": "http://www.douglassandzook.com/terms-and-conditions/",
					"target": "_blank"
				}
			],
			"styles": {
				"backgroundColor": "#0e416b"
			}
		}
	},
	"default": {
		"url": "https://forestlawn.com",
		"data": {
			"copyright": {
				"text": "Forest Lawn Memorial-Park Association"
			},
			"disclaimer": "We respect your privacy and will not sell your personal information. Forest Lawn will collect and use the information you provide here to periodically email, call or text you with information about products, services, and events according to the terms of the Forest Lawn <a href='https://forestlawn.com/privacy/'><u>Privacy Policy and Terms of Use</u></a>   until you change your communication preferences at <a href='https://forestlawn.com/preferences/'><u>www.forestlawn.com/preferences</u></a>.",
			"locations": {
				"corporate": "FOREST LAWN MEMORIAL-PARKS & MORTUARIES",
				"locations": [
					{
						"name": "Arcadia – FD 2186",
						"url": "https://forestlawn.com/parks/arcadia",
						"target": "_blank"
					},
					{
						"name": "Cathedral City – FD 1847",
						"url": "https://flcoachellavalley.com/",
						"target": "_blank"
					},
					{
						"name": "City of Industry – FD 2121",
						"url": "https://forestlawn.com/parks/city-of-industry",
						"target": "_blank"
					},
					{
						"name": "Coachella – FD 640",
						"url": "https://flcoachellavalley.com/",
						"target": "_blank"
					},
					{
						"name": "Covina Hills – FD 1150",
						"url": "https://forestlawn.com/parks/covina-hills",
						"target": "_blank"
					},
					{
						"name": "Cypress – FD 1051",
						"url": "https://forestlawn.com/parks/cypress",
						"target": "_blank"
					},
					{
						"name": "Glendale – FD 656",
						"url": "https://forestlawn.com/parks/glendale",
						"target": "_blank"
					},
					{
						"name": "Hollywood Hills – FD 904",
						"url": "https://forestlawn.com/parks/hollywood-hills",
						"target": "_blank"
					},
					{
						"name": "Indio – FD 967",
						"url": "https://flcoachellavalley.com/",
						"target": "_blank"
					},
					{
						"name": "Long Beach – FD 1151",
						"url": "https://forestlawn.com/parks/long-beach/",
						"target": "_blank"
					},
					{
						"name": "Whittier – FD 2302",
						"url": "https://forestlawn.com/parks/whittier",
						"target": "_blank"
					}
				]
			},
			"menu": [
				{
					"name": "Privacy Policy",
					"url": "https://forestlawn.com/privacy/",
					"target": "_blank"
				},
				{
					"name": "Emergency Portal",
					"url": "https://fl-emergency-portal.appspot.com/",
					"target": "_blank"
				}
			],
			"socials": [
				{
					"name": "Instagram",
					"url": "https://www.instagram.com/forestlawnmemorial/",
					"backgroundImageUrl": "https://forest-lawn.s3-us-west-1.amazonaws.com/wp-content/uploads/2018/03/logo-instagram.svg",
					"target": "_blank"
				},
				{
					"name": "Facebook",
					"url": "https://www.facebook.com/ForestLawn/",
					"backgroundImageUrl": "https://forest-lawn.s3-us-west-1.amazonaws.com/wp-content/uploads/2018/03/logo-fb-simple.svg",
					"target": "_blank"
				}
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/App/data/forestLawnFooter.json
// module id = 1239
// module chunks = 0